import { useQuery } from "@tanstack/react-query";

import { ApiResponse } from "@shared/types";
import { SyncRun } from "@modules/syncReceivedBooks/types";

import { listSyncRunsService } from "./service";
import { ListSyncRunsParams } from "./types";

const ACTIVE_STATUSES = ["queued", "running"];
const POLL_INTERVAL_MS = 5000;

export function useListSyncRunsQuery(params: ListSyncRunsParams) {
  return useQuery<ApiResponse<SyncRun>>({
    queryKey: ["sync-received-books-runs", params],
    queryFn: () => listSyncRunsService(params),
    refetchInterval: (query) => {
      const hasActiveRun = query.state.data?.results.some((run) =>
        ACTIVE_STATUSES.includes(run.status)
      );

      return hasActiveRun ? POLL_INTERVAL_MS : false;
    },
  });
}
